import { Button } from '@mui/material';
import React, { FunctionComponent } from 'react';
import { CS_BASE_URL } from '../../../utils/ProjectUrls';
import { useResponsive } from '../../../contexts/ResponsiveContext';
import { ProductsContent } from '../../../graphql/pimcore/modules/siteContent/types/ProductsContent';

interface ProductSampleButtonProps {
    partNumber: string;
    contentTree: ProductsContent;
}
const ProductSampleButton: FunctionComponent<ProductSampleButtonProps> = ({
    partNumber,
    contentTree,
}) => {
    const handleClickRequestSample = (partNumber: string) => {
        window.open(`${CS_BASE_URL}/sample/${partNumber}`, '_blank');
    };

    const { isMaxScreen, isScreenXxl, isScreenXl, isScreenLg, isScreenMd, isScreenSm, isScreenXs } =
        useResponsive();

    const buttonWidth = (() => {
        if (isMaxScreen || isScreenXxl || isScreenXl || isScreenLg || isScreenMd) return '200.5px';
        return '183.5px';
    })();

    const textSize = (() => {
        if (isMaxScreen || isScreenXxl || isScreenXl || isScreenLg || isScreenMd) return '1rem';
        return '14px';
    })();

    return (
        <Button
            variant="contained"
            sx={{
                backgroundColor: '#B75332',
                width: buttonWidth,
                height: '39px',
                borderRadius: '5px',
                // 上下为 10px，左右为 20px
                padding: '10px 20px',
                // 元素之间的间距}
                gap: '10px',
                fontWeight: '400',
                fontFamily: 'Poppins',
                fontSize: textSize,
                transition: 'none',
                '&:hover': {
                    background: 'linear-gradient(0deg, #B75332 0%, #E58869 100%)',
                    transition: 'none',
                },
            }}
            onClick={() => handleClickRequestSample(encodeURIComponent(partNumber))}
        >
            {contentTree.product.requestSample.content} →
        </Button>
    );
};

export default ProductSampleButton;
